import React, { type JSX } from 'react'

import { PropsWithClassName } from '@helper/PropsWithClassName'
import { cn } from '@helper/utils/cn'

import { Root } from './Col.styles'

interface Props extends PropsWithClassName {
  xs?: number
  xsOffset?: number
  sm?: number
  smOffset?: number
  md?: number
  mdOffset?: number
  lg?: number
  lgOffset?: number
  children?: React.ReactNode
}

type ColBreakpointProps = Pick<
  Props,
  'xs' | 'xsOffset' | 'sm' | 'smOffset' | 'md' | 'mdOffset' | 'lg' | 'lgOffset'
>

const COL_BREAKPOINT_SPECS: {
  key: keyof ColBreakpointProps
  prefix: string
}[] = [
  { key: 'xs', prefix: 'col-xs' },
  { key: 'xsOffset', prefix: 'col-xs-offset' },
  { key: 'sm', prefix: 'col-sm' },
  { key: 'smOffset', prefix: 'col-sm-offset' },
  { key: 'md', prefix: 'col-md' },
  { key: 'mdOffset', prefix: 'col-md-offset' },
  { key: 'lg', prefix: 'col-lg' },
  { key: 'lgOffset', prefix: 'col-lg-offset' },
]

function colBreakpointClasses(breakpoints: ColBreakpointProps): string[] {
  return COL_BREAKPOINT_SPECS.flatMap(({ key, prefix }) => {
    const value = breakpoints[key]
    return value !== undefined ? [`${prefix}-${value}`] : []
  })
}

const Col = (props: Props): JSX.Element => {
  const { className, children, dataTestId, ...breakpoints } = props

  return (
    <Root className={cn(className, colBreakpointClasses(breakpoints))} data-testid={dataTestId ?? 'Col-root'}>
      {children}
    </Root>
  )
}

export { Col }
